module.exports = __webpack_public_path__ + "static/media/playTrack.4b9306cf.svg";